/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getMedicines } from 'app/entities/medicine/medicine.reducer';
import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { createEntity, getEntity, reset, updateEntity } from './medication-details.reducer';

export const MedicationDetailsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const medicines = useAppSelector(state => state.medicine.entities);
  const prescriptions = useAppSelector(state => state.prescription.entities);
  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const medicationDetailsEntity = useAppSelector(state => state.medicationDetails.entity);
  const loading = useAppSelector(state => state.medicationDetails.loading);
  const updating = useAppSelector(state => state.medicationDetails.updating);
  const updateSuccess = useAppSelector(state => state.medicationDetails.updateSuccess);
  const patientTypeValues = Object.keys(PatientType);

  const handleClose = () => {
    navigate(`/medication-details${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getMedicines({}));
    dispatch(getPrescriptions({}));
    dispatch(getPharmacies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.tmEnd !== undefined && typeof values.tmEnd !== 'number') {
      values.tmEnd = Number(values.tmEnd);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.prescribedCount !== undefined && typeof values.prescribedCount !== 'number') {
      values.prescribedCount = Number(values.prescribedCount);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }

    const entity = {
      ...medicationDetailsEntity,
      ...values,
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
      medicine: medicines.find(it => it.id.toString() === values.medicine?.toString()),
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      servedBy: pharmacies.find(it => it.id.toString() === values.servedBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientType: 'OP',
          ...medicationDetailsEntity,
          glucoUser: medicationDetailsEntity?.glucoUser?.id,
          medicine: medicationDetailsEntity?.medicine?.id,
          prescription: medicationDetailsEntity?.prescription?.id,
          servedBy: medicationDetailsEntity?.servedBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.medicationDetails.home.createOrEditLabel" data-cy="MedicationDetailsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.medicationDetails.home.createOrEditLabel">Create or edit a MedicationDetails</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="medication-details-id"
                  label={translate('tinyMedicRestApp.medicationDetails.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.repetition')}
                id="medication-details-repetition"
                name="repetition"
                data-cy="repetition"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.tmEnd')}
                id="medication-details-tmEnd"
                name="tmEnd"
                data-cy="tmEnd"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.currentSupply')}
                id="medication-details-currentSupply"
                name="currentSupply"
                data-cy="currentSupply"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.refillSize')}
                id="medication-details-refillSize"
                name="refillSize"
                data-cy="refillSize"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.timestampentry')}
                id="medication-details-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.active')}
                id="medication-details-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.lastupdated')}
                id="medication-details-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.cursor')}
                id="medication-details-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.microSec')}
                id="medication-details-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.prescribedCount')}
                id="medication-details-prescribedCount"
                name="prescribedCount"
                data-cy="prescribedCount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.indication')}
                id="medication-details-indication"
                name="indication"
                data-cy="indication"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.daysFrequency')}
                id="medication-details-daysFrequency"
                name="daysFrequency"
                data-cy="daysFrequency"
                type="text"
                validate={{
                  maxLength: { value: 250, message: translate('entity.validation.maxlength', { max: 250 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.endDate')}
                id="medication-details-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.dose')}
                id="medication-details-dose"
                name="dose"
                data-cy="dose"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.route')}
                id="medication-details-route"
                name="route"
                data-cy="route"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.stopped')}
                id="medication-details-stopped"
                name="stopped"
                data-cy="stopped"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.stoppedBy')}
                id="medication-details-stoppedBy"
                name="stoppedBy"
                data-cy="stoppedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.patientType')}
                id="medication-details-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.exposed')}
                id="medication-details-exposed"
                name="exposed"
                data-cy="exposed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.medicineName')}
                id="medication-details-medicineName"
                name="medicineName"
                data-cy="medicineName"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.doseInstructions')}
                id="medication-details-doseInstructions"
                name="doseInstructions"
                data-cy="doseInstructions"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationDetails.tmType')}
                id="medication-details-tmType"
                name="tmType"
                data-cy="tmType"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                id="medication-details-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.medicationDetails.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="medication-details-medicine"
                name="medicine"
                data-cy="medicine"
                label={translate('tinyMedicRestApp.medicationDetails.medicine')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="medication-details-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.medicationDetails.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="medication-details-servedBy"
                name="servedBy"
                data-cy="servedBy"
                label={translate('tinyMedicRestApp.medicationDetails.servedBy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/medication-details" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MedicationDetailsUpdate;
